<script lang="ts">
	import { Rive } from '@rive-app/canvas';
	import { onMount } from 'svelte';
	import { streamAnswerAnimationTriggers } from '$lib/stores/animationStores';
	import { appStore } from '$lib/stores/appStore';
	export let isNewMessage: boolean;

	const resolution: number = 140; //resolution of canvas
	const filePath = `${import.meta.env.VITE_HOST || location.origin}/rive-files/typewriter.riv`; //path to rive file
	const inputNames = ['done', 'dark', 'light', 'isNewMessage'];
	const UUID = crypto.randomUUID();

	let canvas: HTMLCanvasElement;

	$: {
		if ($appStore?.chatWidgetParams?.appearance?.animationColor === 'light') {
			$streamAnswerAnimationTriggers[UUID]?.light?.fire();
		} else {
			$streamAnswerAnimationTriggers[UUID]?.dark?.fire();
		}
	}

	$: {
		if (!isNewMessage) {
			$streamAnswerAnimationTriggers[UUID]?.done?.fire();
		}
	}

	onMount(() => {
		const rive = new Rive({
			src: filePath,
			canvas: canvas,
			autoplay: true,
			stateMachines: 'State Machine 1',
			onLoad: (_) => {
				const inputs = rive.stateMachineInputs('State Machine 1');
				$streamAnswerAnimationTriggers[UUID] = {};
				inputNames.forEach((name) => {
					const input = inputs.find((i) => i.name === name);
					if (input) {
						$streamAnswerAnimationTriggers[UUID][name] = input;
					}
				});
				if (!isNewMessage) {
					$streamAnswerAnimationTriggers[UUID].isNewMessage.value = false;
				}
			}
		});

		return () => {
			rive.cleanup();
		};
	});
</script>

<canvas width={resolution} height={resolution} bind:this={canvas} />

<style lang="scss">
	canvas {
		height: 70px;
		width: 70px;
	}
</style>
